module.exports = __webpack_public_path__ + "img/profile-pic.a334ac80.webp";